import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/customers/groups/')({
  validateSearch: (search: Record<string, unknown>) => {
    const tab = search.tab;
    return {
      tab: tab === 'all' || tab === 'manual' || tab === 'automated' ? tab : undefined,
    };
  },
});
